import { RunFromSheetForm } from '../../../fragments/admin/price-extractions/RunFromSheetForm'

const RunFromSheet = () => {
    return (
        <main>
            <RunFromSheetForm />
        </main>
    )
}

export default RunFromSheet
